import { api } from '@/lib/api'
import type {
  Account,
  DeleteStatementsPayload,
  StatementsQueryArgs,
  StatementsResponse,
} from './types'

function buildQuery({ page, limit, sort, filters }: StatementsQueryArgs): Record<string, string> {
  const q: Record<string, string> = {
    page: String(page),
    limit: String(limit),
    sortColumn: sort.column,
    sortDirection: sort.direction,
  }
  for (const [k, v] of Object.entries(filters)) {
    if (v) q[k] = v
  }
  return q
}

export type UpdateStatementPayload = {
  category?: string
  classified_account_code?: string
  coa?: {
    statement_type?: string
    main_category?: string
    subcategory?: string
    account_code?: string
  }
}

export type SplitLine = {
  amount: number
  description?: string | null
  category?: string | null
  classified_account_code?: string | null
  coa?: {
    statement_type?: string
    main_category?: string
    subcategory?: string
  } | null
}

export type SplitPayload = {
  originalAmount: number
  splits: SplitLine[]
}

export const viewStatementsApi = {
  accounts: () => api.get<Account[]>('/api/statements/accounts'),
  list: (args: StatementsQueryArgs) =>
    api.get<StatementsResponse>('/api/statements/', { query: buildQuery(args) }),
  requestDeleteCode: () =>
    api.post<{ message?: string }>('/api/auth/request-delete-code', { context: 'statements' }),
  deleteData: (payload: DeleteStatementsPayload) =>
    api.post<{ deletedCount: number; message?: string }>('/api/statements/delete-data', payload),
  update: (id: number, payload: UpdateStatementPayload) =>
    api.put<{ message?: string; updatedStatement?: unknown }>(`/api/statements/${id}`, payload),
  split: (id: number, payload: SplitPayload) =>
    api.post<{ message?: string }>(`/api/statements/${id}/split`, payload),
  categoryLookup: (accountCode: string, subcategory: string) =>
    api.get<{ category: string | null }>('/api/statements/category-lookup', {
      query: { accountCode, subcategory },
    }),
}
